import { CardNumberComponent } from './cardNumber.component';
import { CardVerificationValueComponent } from './cardVerificationValue.component';
import { ExpirationDateComponent } from './expirationDate.component';
import { PaymentMethodComponent } from './paymentMethod.component';
import { PostalCodeComponent } from './postalCode.component';
import { ValidCardNumberDirective } from './valid_card_number.directive';
import { ValidExpirationDateDirective } from './valid_expiration_date.directive';
import { CreditCardIdentifierService } from './credit_card_identifier.service';

export const CreditCardBitsModule = angular
    .module('oo.checkout.checkoutSteps.payment.creditCardBits', [])
    .component('creditCardNumber', CardNumberComponent)
    .component('cardVerificationValue', CardVerificationValueComponent)
    .component('cardExpirationDate', ExpirationDateComponent)
    .component('paymentMethod', PaymentMethodComponent)
    .component('cardPostalCode', PostalCodeComponent)
    .directive('validCardNumber', ValidCardNumberDirective)
    .directive('validExpirationDate', ValidExpirationDateDirective)
    .service('CreditCardIdentifierService', CreditCardIdentifierService)
    .name;
